<template>
  <div class="container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>概览</el-breadcrumb-item>
    </el-breadcrumb>
    <el-main>
      <div class="websites_container">
        <el-card class="websites_dashboard">
          <div class="websites_echarts_box" id="chart1" v-loading="chart1Loading">

          </div>
        </el-card>
        <!-- <p class="text-extra-small">用 Element 快速搭建页面（辅助文字）</p>
            <p class="text-small">用 Element 快速搭建页面（正文小）</p>
            <p class="text-base">用 Element 快速搭建页面（正文）</p>
            <p class="text-medium">用 Element 快速搭建页面（小标题）</p>
            <p class="text-large">用 Element 快速搭建页面（标题）</p>
            <p class="text-extra-large">用 Element 快速搭建页面（主标题）</p> -->
        <div class="websites_operation_area">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span class="text-base">站点数量</span>
              <el-button type="primary" size="mini" style="float: right;"
                @click="$router.push('/websites/list')">站点管理</el-button>
            </div>
            <p class="text-base"><span class="blue text-large" v-loading="totalLoading">{{ total }}</span> 个</p>
          </el-card>
          <!-- <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span class="text-base">站点数量</span>
              <el-button type="primary" size="mini" style="float: right;"
                @click="$router.push('/websites/list')">站点管理</el-button>
            </div>
            <p class="text-base"><span class="blue text-large" v-loading="totalLoading">{{ total }}</span> 个</p>
          </el-card> -->
        </div>
      </div>
    </el-main>
  </div>
</template>

<script>
import Nav from '../../Global/Nav.vue'
export default {
  name: 'Websites',
  components: {
    Nav
  },
  data() {
    return {
      uploadApi: this.$axios.defaults.baseURL + 'excel/upload',
      headersObj: {
        'x-authorization-token': this.$userinfo.api_token
      },
      totalLoading: true,
      total: 0,
      chart1Loading: true
    }
  },
  mounted() {
    this.getWebsitesTotal();
    this.drawChart1();
  },
  methods: {
    async getWebsitesTotal() {
      await this.$axios.get(`/websites/backend/total`).then((response) => {
        this.totalLoading = false;
        if (response.data.code === 200) {
          this.total = response.data.data
        }
      });
    },
    async drawChart1() {
      var dom = document.getElementById('chart1');
      var chart = this.$echarts.init(dom);
      const dataCount = 100;
      const data = this.generateData(dataCount);
      let option = {
        title: {
          text: '网站流量统计',
          left: 10
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: false
            },
            saveAsImage: {
              pixelRatio: 2
            }
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          bottom: 90
        },
        dataZoom: [
          {
            type: 'inside'
          },
          {
            type: 'slider'
          }
        ],
        xAxis: {
          data: data.categoryData,
          silent: false,
          splitLine: {
            show: false
          },
          splitArea: {
            show: false
          }
        },
        yAxis: {
          splitArea: {
            show: false
          }
        },
        series: [
          {
            type: 'bar',
            data: data.valueData,
            // Set `large` for large data amount
            large: true
          }
        ]
      };
      this.chart1Loading = false;
      chart.setOption(option);
    },
    generateData(count) {
      let baseValue = Math.random() * 1000;
      let time = +new Date(2011, 0, 1);
      let smallBaseValue;
      function next(idx) {
        smallBaseValue =
          idx % 30 === 0
            ? Math.random() * 700
            : smallBaseValue + Math.random() * 500 - 250;
        baseValue += Math.random() * 20 - 10;
        return Math.max(0, Math.round(baseValue + smallBaseValue) + 3000);
      }
      const categoryData = [];
      const valueData = [];
      for (let i = 0; i < count; i++) {
        categoryData.push(
          this.$echarts.format.formatTime('yyyy-MM-dd\nhh:mm:ss', time, false)
        );
        valueData.push(next(i).toFixed(2));
        time += 1000;
      }
      return {
        categoryData: categoryData,
        valueData: valueData
      };
    }
  },
  beforeDestroy() {
    clearInterval(this.intervals);
  }
}
</script>

<style scoped>
.websites_container {
  width: 98%;
  height: 80vh;
  overflow: auto;
  display: flex;
  justify-content: space-between;
}

.websites_dashboard {
  width: 78%;
  height: 600px;
  border: solid 1px rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}

.websites_operation_area {
  width: 20%;
}

.box-card {
  margin-bottom: 40px;
}

.websites_echarts_box {
  width: 100%;
  height: 550px;
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/Modules/Websites/Index.vue